<template lang="pug">
#layout(:class='name')
  .wrapper.centered
    .main-panel(:class="{ 'loading' : loading }")
      .auth-layout-wrapper
        .auth-header
        .auth-top
          .container-fluid
            ed-button.pull-right.btn.btn-actionbar-.btn-success(:class='{ invisible: isLoggedIn }' :href='env + "/SignUp"') Sign-up
            .logo
              img(src='~images/../logo-default.svg', height='44')
        .container
          .row
            .auth-main-body.col-md-4.col-md-offset-4.offset-md-4.col-sm-8.col-sm-offset-2.offset-sm-2
              slot
        .container
          .row
            .col-md-4.col-md-offset-4.offser-md-4.text-right-.text-center
              .logo-.partner-
                //-img(src='~images/../logo-default.svg', height='25')
                p.row
                  br
                  br
                  img(id="assuranceCardSeal" src="https://produs-ccs-assurancecard-service.sgsonline.net/img/thumb.png" style="cursor:pointer; height:40px; width:auto; border-radius:4px; box-shadow:0 1px 6px rgba(0,0,0,0.25);" onclick="javascript:window.open('https://produs-ccs-assurancecard-service.sgsonline.net/assurancecard/be8e7fbc4499573f9c0088ceb2764691963efb6620c58fb42c6f7104e6fc6247/assurancecard', 'assurance_card', 'location=no, menubar=no, resizable=yes, scrollbars=yes, width=500, height=535, top=100, left=100'); return false;" alt="VikingCloud Assurance Card" title="VikingCloud Assurance Card" border="0")
                p.row
                  br
      md-footer.visible
</template>

<script>

import MdFooter from '@/components/Footer'

export default {
  components: {
    MdFooter
  },
  data() {
    return {
      name: 'layout-auth ' + (this.$route.query.sk ? 'loading' : ''),
      env: this.api.env
    }
  },
  computed: {
    loading() {
      return this.$loading
    },
    isLoggedIn() {
      return this.$store.state.isLoggedIn ||
        typeof this.$route.query.mfa !== 'undefined' ||
        !!~this.$route.path.indexOf('mfa-')
    }
  }
}

</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.layout-auth .main-panel {
  background: $background-light;
  @include theme {
  background: v(background-light);
  }
}

.layout-auth .logo.partner {
  img { display: none; }

  margin-top: 15px;
  background-repeat: no-repeat;
  background-image: url(~images/../logo-default.svg);
  background-size: contain;
  background-position: 50% 0;
  width: auto;
  min-height: 30px;
  opacity: .25;
}

// Some Bootstrap Layout Overrides
.container-fluid {
  margin-right: auto;
  margin-left: auto;
  max-width: 1200px;
  padding-left: 1rem;
  padding-right: 1rem;
  transition: all .5s ease-out;
  position: relative;
}

body {
  background-color: $canvas;
  @include theme {
  background-color: v(canvas);
  }
  height: 100vh;
}

.logo {
  margin-top: -1rem;
  padding-bottom: .75rem;
}

.auth-layout-wrapper {
  background: $background-light;
  @include theme {
  background: v(background-light);
  }
  padding-bottom: 1rem;
  height: 100vh;
}

.auth-header {
  width: 100%;
  height: .85rem;
  background: $primary-05;
  @include theme {
  background: v(primary-05);
  }
  padding: 0rem $side-padding;
}

.auth-top {
  width: 100%;
  background: $primary-04;
  @include theme {
  background: v(primary-04);
  }
  padding: 1rem $side-padding;
}

.auth-main-body {
  background: $canvas;
  @include theme {
  background: v(canvas);
  }
  padding: 1rem;
  border-radius: $border-radius;
  margin-top: -2rem;
  box-shadow: $box-shadow;

  @include media('<phone') {
    margin-top: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Layouts/auth.vue